import { styled } from '@mui/material';

export const Wrap = styled('div')({
	display: 'flex',
	alignItems: 'center',
	gap: '24px',
});

export const Step = styled('div', {
	shouldForwardProp: (prop) => prop !== 'isActive' && prop !== 'isStudent',
})<{
	isActive?: boolean;
	isStudent?: boolean;
}>(({ theme, isActive, isStudent }) => ({
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	flexShrink: 0,
	borderRadius: '50%',
	color: '#fff',
	transition: 'all .3s',
	clipPath: `polygon(
        47.5% 5.66987%,
        48.2899% 5.30154%,
        49.13176% 5.07596%,
        50% 5%,
        50.86824% 5.07596%,
        51.7101% 5.30154%,
        52.5% 5.66987%,
        87.14102% 25.66987%,
        87.85495% 26.16978%,
        88.47124% 26.78606%,
        88.97114% 27.5%,
        89.33948% 28.2899%,
        89.56505% 29.13176%,
        89.64102% 30%,
        89.64102% 70%,
        89.56505% 70.86824%,
        89.33948% 71.7101%,
        88.97114% 72.5%,
        88.47124% 73.21394%,
        87.85495% 73.83022%,
        87.14102% 74.33013%,
        52.5% 94.33013%,
        51.7101% 94.69846%,
        50.86824% 94.92404%,
        50% 95%,
        49.13176% 94.92404%,
        48.2899% 94.69846%,
        47.5% 94.33013%,
        12.85898% 74.33013%,
        12.14505% 73.83022%,
        11.52876% 73.21394%,
        11.02886% 72.5%,
        10.66052% 71.7101%,
        10.43495% 70.86824%,
        10.35898% 70%,
        10.35898% 30%,
        10.43495% 29.13176%,
        10.66052% 28.2899%,
        11.02886% 27.5%,
        11.52876% 26.78606%,
        12.14505% 26.16978%,
        12.85898% 25.66987%
    );`,

	...(isActive
		? {
				width: '40px',
				height: '40px',
				background: isStudent ? theme.palette.error.contrastText : '#E70000',
				fontSize: '16px',
			}
		: {
				width: '24px',
				height: '24px',
				background: '#989A9D',
				fontSize: '8px',
			}),
}));
